import { useEffect, useState } from "react";
import { isAuthenticated } from "../services/Auth";
import { useMeQuery } from "../queries";

export const useIsAuth = () => {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    (async () => {
      !(await isAuthenticated()) ? setIsAuth(false) : setIsAuth(true);
    })();
  });

  return isAuth;
};

export const useUserName = (): string|null => {
  const [userName, setUserName] = useState<string|null>(null);

  const me = useMeQuery();

  useEffect(() => {
    if (me.status === "success" && me.data) {
      setUserName(me.data?.username || null);
    }
  }, [me.status, me.data]);

  return userName;
};
